// Section 8: the job registry. Keys are job ids; JobId is derived from config.jobs.
import type { Config } from '../../config';
import { checkRegistryKeys, type JobDef } from '../../core/registry';
import type { JobId } from '../../core/types';
import { builder } from './builder';
import { caretaker } from './caretaker';
import { farmer } from './farmer';
import { forager } from './forager';
import { guard } from './guard';
import { healer } from './healer';
import { hunter } from './hunter';
import { quarrier } from './quarrier';
import { rest } from './rest';
import { teacher } from './teacher';
import { toolmaker } from './toolmaker';
import { waterCarrier } from './water-carrier';
import { weaver } from './weaver';
import { woodcutter } from './woodcutter';

/** Build the jobs registry for a config (content numbers come from the config, ADR-0008). */
export function buildJobs(config: Config) {
  const jobs = Object.freeze({
    farmer: farmer(config),
    forager: forager(config),
    hunter: hunter(config),
    'water-carrier': waterCarrier(config),
    woodcutter: woodcutter(config),
    quarrier: quarrier(config),
    builder: builder(config),
    toolmaker: toolmaker(config),
    healer: healer(config),
    teacher: teacher(config),
    caretaker: caretaker(config),
    guard: guard(config),
    weaver: weaver(config),
    rest: rest(config),
  } satisfies Record<JobId, JobDef>);
  checkRegistryKeys('jobs', jobs);
  return jobs;
}
